import { Modal } from '@mui/material'
import React from 'react'
import '../styles/Modal.scss'

const PushNotificationPopup = ({
  handlePushNotificationsModal,
  modalOpen = false,
}) => {
  return (
    <>
      {modalOpen && (
        <Modal
          open={modalOpen}
          onClose={() => handlePushNotificationsModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="push-notification-popup p-3">
            <p className="fs-16 color-primary mb-1 fw-bold">
              Service provider on their way
            </p>
            <p className="fs-12">
              Phasellus finibus enim nulla, quis ornare odio facilisis <br />{' '}
              eu. Suspendisse ornare ante sit amet arcu semper, vel <br />{' '}
              eleifend tortor egestas.
            </p>
          </div>
        </Modal>
      )}
    </>
  )
}

export default PushNotificationPopup
